import { Box, Stack } from '@mui/material';
import React from 'react';

import { StyledSkeleton } from '../../theme/CustomComponents';

interface CommentSkeletonProps {
  depth?: number;
}

const CommentSkeleton: React.FC<CommentSkeletonProps> = ({ depth = 0 }) => {
  return (
    <Box sx={{ pl: depth * 4, mt: depth > 0 ? 2 : 0 }}>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <StyledSkeleton variant="circular" width={40} height={40} />
        <Box flexGrow={1}>
          <StyledSkeleton width="30%" height={20} />
          <StyledSkeleton width="20%" height={15} />
          <StyledSkeleton sx={{ mt: 1 }} width="100%" height={60} />
          <Stack direction="row" spacing={1} mt={1}>
            <StyledSkeleton variant="rectangular" width={60} height={30} />
            <StyledSkeleton variant="rectangular" width={60} height={30} />
            <StyledSkeleton variant="rectangular" width={60} height={30} />
          </Stack>
        </Box>
      </Stack>
      <StyledSkeleton
        variant="rectangular"
        height={1}
        width="100%"
        sx={{ mt: 2, bgcolor: 'divider' }}
      />
    </Box>
  );
};

export default CommentSkeleton;
